import { render, staticRenderFns } from "./StatsTableTotemV2.vue?vue&type=template&id=a1ba1294&"
import script from "./StatsTableTotemV2.vue?vue&type=script&lang=js&"
export * from "./StatsTableTotemV2.vue?vue&type=script&lang=js&"
import style0 from "./StatsTableTotemV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VProgressLinear,VSelect,VSimpleTable})
